module.exports = __webpack_public_path__ + "img/cb1845739aa8c3becbebc216494ce77c.png";